import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { observer, inject } from 'mobx-react';
import gou from '../../../imges/settled/gou.png';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import StepNew from './StepNew';

const Main = inject('stepStore')(observer((props: any) => {
  useEffect(() => {
    return () => {
      props.stepStore.reset()
    }
    // eslint-disable-next-line
  }, [])

  const StepItem = ({ index, title, desc }: { index: number, title: string, desc: string }) => (
    <StepItemStyle active={index === props.stepStore.currentStep} finish={index < props.stepStore.currentStep}>
      <div>
        <p className={index <= props.stepStore.currentStep ? 'p-active' : 'p-normal'}>{title}</p>
        <p>{desc}</p>
      </div>
    </StepItemStyle>
  )

  const Step = () => (
    <StepStyle>
      <StepItem index={1} title='01' desc='填写基本资料' />
      <StepItem index={2} title='02' desc='填写联系方式' />
      <StepItem index={3} title='03' desc='完成入驻申请' />
    </StepStyle>
  )

  const renderContent = () => {
    switch (props.stepStore.currentStep) {
      case 1:
        return <StepNew stepStore={props.stepStore} />;
      case 2:
        return <Step2 />;
      case 3:
        return <Step3 />;
    }
  }

  return (
    <Container>
      <MainStyle>
      <MyNewHeader>
      供应商入驻申请
      </MyNewHeader>
        {renderContent()}
      </MainStyle>
    </Container>
  )
}))

export default Main;

const Container = styled.section`
  width: 1160px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const MyNewHeader = styled.div`
  width: 100%;
  font-size: 28px;
  margin-top: 45px;
  margin-bottom: 50px;
  font-weight: 500;
  color: #3E3F3F;
  line-height: 40px;
  text-align: center;
`

const StepStyle = styled.div`
  position: relative;
  display: flex;
  width: 100vw;
  height: 180px;
  background: #FAFAFA;
  justify-content: center;
  margin-bottom: 49px;
  
  > div:nth-of-type(1) {
    &:after {
      position: absolute;
      content: '';
      width: 600px;
      height: 2px;
      background: #D3E7FF;
      top: 69px;
      left: 50%;
      z-index: 1;
    }
  }
`
const active = css`
  background: #1967FA;
  box-shadow:0 4px 9px 0 rgba(221,224,236,1);
  color:rgba(255,255,255,1);
`
const normal = css`
  background: white;
  color:#686868;
  border: 1px solid #D9DCE6;
`
const finish = css`
  background: white url(${gou}) no-repeat center center;
  background-size: 15px 13px;
  border: 1px solid #78CA3C;
`
const StepItemStyle = styled.div`
  position: relative;
  z-index: 2;
  width: 300px;
  height: 180px;
  display: flex;
  justify-content: center;
  >div{
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .p-active {
      color: #FFFFFF;
      background: #1968FC;;
    }
    .p-normal {
      background: #F8F8F8;
      color: #1F6BFB;
    }
    p:nth-child(1) {
      font-size: 18px;
      line-height: 60px;
      text-align: center;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 2px solid #1F6BFB;
      z-index: 2;
    }
    p:nth-child(2){
      margin-top: 12px;
      font-size:16px;
      font-weight: bold;
      color:#3E3F3F;
      line-height:32px;
    }
  }
  /* >p{
      vertical-align: middle;
      display: inline-block;
      width:32px;
      height:32px;
      border-radius: 50%;
      font-size:16px;
      line-height:32px;
      text-align: center;
      ${(props: { active: boolean, finish: boolean }) => (
    props.active ? active : props.finish ? finish : normal
  )}
    } */
`

const MainStyle = styled.div`
  vertical-align: top;
  display: inline-block;
  width: 1200px;
  margin: 22px auto 0;
  padding-bottom: 40px;
  background: #FFFFFF;
  border-radius: 4px;
`